module.exports = __webpack_public_path__ + "img/vis_07.04b4d915.jpg";